import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { infoColor } from './status/info';

export const info = (mode: PaletteMode): SimplePaletteColorOptions => {
  const color = infoColor(mode);
  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
